(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aspect-ratio-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aspect-ratio-slideshow')) {
    customElements.define(
      'aspect-ratio-slideshow',
      class AspectRatioSlideshow extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.current = 0;
          this.timer = null;
          this.autoplayEnabled = this.dataset.autoplay === 'true';
          this.interval = Number(this.dataset.interval || 5) * 1000;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.prevButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          this.dotsWrap = this.querySelector('[data-dots]');
          this.viewport = this.querySelector('.aspect-ratio-slideshow__viewport');
          this.mediaQuery = window.matchMedia('(max-width: 749px)');
          this.pointerStartX = 0;
          this.pointerDeltaX = 0;

          if (this.slides.length === 0) return;

          this.applyFrameSize();
          this.buildDots();
          this.goTo(0, true);
          this.bindEvents();

          if (this.autoplayEnabled && !this.reduceMotion && this.slides.length > 1) {
            this.play();
          }
        }

        disconnectedCallback() {
          this.pause();
          this.unbindEvents();
        }

        bindEvents() {
          this.onPrev = () => this.goTo(this.current - 1);
          this.onNext = () => this.goTo(this.current + 1);
          this.onMouseEnter = () => this.pause();
          this.onMouseLeave = () => {
            if (this.autoplayEnabled && !this.reduceMotion) this.play();
          };
          this.onVisibility = () => {
            if (document.hidden) {
              this.pause();
            } else if (this.autoplayEnabled && !this.reduceMotion) {
              this.play();
            }
          };
          this.onKeyDown = (event) => {
            if (event.key === 'ArrowLeft') this.goTo(this.current - 1);
            if (event.key === 'ArrowRight') this.goTo(this.current + 1);
          };
          this.onPointerDown = (event) => {
            this.pointerStartX = event.clientX;
            this.pointerDeltaX = 0;
          };
          this.onPointerUp = (event) => {
            this.pointerDeltaX = event.clientX - this.pointerStartX;
            if (Math.abs(this.pointerDeltaX) < 40) return;
            if (this.pointerDeltaX > 0) this.goTo(this.current - 1);
            else this.goTo(this.current + 1);
          };
          this.onBlockSelect = (event) => {
            const slide = event.target.closest('[data-slide]');
            if (!slide || !this.contains(slide)) return;
            this.goTo(this.slides.indexOf(slide), true);
            this.pause();
          };
          this.onBlockDeselect = (event) => {
            const slide = event.target.closest('[data-slide]');
            if (!slide || !this.contains(slide)) return;
            if (this.autoplayEnabled && !this.reduceMotion) this.play();
          };
          this.onMediaChange = () => this.applyFrameSize();

          this.prevButton?.addEventListener('click', this.onPrev);
          this.nextButton?.addEventListener('click', this.onNext);
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
          this.addEventListener('keydown', this.onKeyDown);
          this.addEventListener('pointerdown', this.onPointerDown);
          this.addEventListener('pointerup', this.onPointerUp);
          this.mediaQuery.addEventListener('change', this.onMediaChange);
          document.addEventListener('visibilitychange', this.onVisibility);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        unbindEvents() {
          this.prevButton?.removeEventListener('click', this.onPrev);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.removeEventListener('mouseenter', this.onMouseEnter);
          this.removeEventListener('mouseleave', this.onMouseLeave);
          this.removeEventListener('keydown', this.onKeyDown);
          this.removeEventListener('pointerdown', this.onPointerDown);
          this.removeEventListener('pointerup', this.onPointerUp);
          this.mediaQuery?.removeEventListener('change', this.onMediaChange);
          document.removeEventListener('visibilitychange', this.onVisibility);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        applyFrameSize() {
          const first = this.slides[0];
          if (!first || !this.viewport) return;
          const desktopRatio = Number(first.dataset.desktopRatio);
          const mobileRatio = Number(first.dataset.mobileRatio);
          const ratio = this.mediaQuery.matches && mobileRatio ? mobileRatio : desktopRatio;
          if (!ratio) return;
          this.viewport.style.height = '0px';
          this.viewport.style.paddingBottom = `${100 / ratio}%`;
          this.viewport.style.aspectRatio = 'auto';
        }

        buildDots() {
          if (!this.dotsWrap) return;
          this.dotsWrap.replaceChildren();
          this.slides.forEach((slide, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'aspect-ratio-slideshow__dot';
            button.setAttribute('aria-label', `Go to slide ${index + 1}`);
            button.addEventListener('click', () => this.goTo(index));
            this.dotsWrap.appendChild(button);
          });
          this.dots = Array.from(this.dotsWrap.children);
        }

        play() {
          this.pause();
          if (this.slides.length < 2) return;
          this.timer = window.setInterval(() => this.goTo(this.current + 1), this.interval);
        }

        pause() {
          if (!this.timer) return;
          window.clearInterval(this.timer);
          this.timer = null;
        }

        goTo(index, instant) {
          if (this.slides.length === 0) return;
          const total = this.slides.length;
          this.current = ((index % total) + total) % total;

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === this.current;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            if (isActive) slide.removeAttribute('inert');
            else slide.setAttribute('inert', '');
          });

          this.dots?.forEach((dot, dotIndex) => {
            const isActive = dotIndex === this.current;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          if (instant) return;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
